import locationsService from "@/services/locations";
import serviceHandler from "@/helpers/handlers/service";

export default {
  async fetchSuggestedLocations({ commit }, { id, isBusinessAddress = true }) {
    const payload = isBusinessAddress
      ? `?business_address_id=${id}`
      : `?website_id=${id}`;

    const data = await serviceHandler(
      locationsService.getSuggestedLocations(payload)
    );

    commit("SET_SUGGESTED_LOCATIONS", data);
  },

  async fetchSearchLocations({ commit }) {
    const searchLocations = await serviceHandler(
      locationsService.getSearchLocations()
    );

    commit("SET_SEARCH_LOCATIONS", searchLocations);
  },

  async removeSuggestedLocation(ctx, suggestedLocation) {
    await serviceHandler(
      locationsService.rejectSuggestedLocation(suggestedLocation)
    );
  }
};
